import { Dispatch, SetStateAction, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";

const FacilityTopbar = ({
  toggleModal,
  searchTerm,
  setDebouncedSearchTerm,
  setSearchTerm,
}: {
  toggleModal: () => void;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary" onClick={toggleModal}>
            <AddIcon /> Add
          </Button>
        </div>
      </div>
    </>
  );
};

export default FacilityTopbar;
